import { createSlice } from '@reduxjs/toolkit';
import { all, takeLatest } from 'redux-saga/effects';
import { createFetchAction, createSaga, fetchInitialState, fetchReducerActions } from 'store/utils';
import * as serialApi from 'api/serial';

interface InitialState {
  productSerialList: object | any;
  updateSerial: object | any;
  deleteSerial: object | any;
}

export const fetch_product_serial_list = createFetchAction('fetch_product_serial_list');
export const update_product_serial = createFetchAction('update_product_serial');
export const delete_product_serial = createFetchAction('delete_product_serial');

const initialState: InitialState = {
  // NOTE: 최초 랜딩시 storage값 유무 확인
  productSerialList: { ...fetchInitialState, data: null },
  updateSerial: { ...fetchInitialState, data: null },
  deleteSerial: { ...fetchInitialState, data: null },
};

const slice = createSlice({
  name: 'serial',
  initialState,
  reducers: {
    ...fetchReducerActions(fetch_product_serial_list, 'productSerialList'),
    ...fetchReducerActions(update_product_serial, 'updateSerial'),
    ...fetchReducerActions(delete_product_serial, 'deleteSerial'),
  },
});

export const name = slice.name;
export const actions: any = slice.actions;

export function* serialSaga() {
  yield all([
    takeLatest(
      actions.fetch_product_serial_list_request,
      createSaga(actions, 'fetch_product_serial_list', serialApi.fetchProductSerialList),
    ),
    takeLatest(
      actions.update_product_serial_request,
      createSaga(actions, 'update_product_serial', serialApi.updateProductSerial, {
        isAlertSuccess: true,
      }),
    ),
    takeLatest(
      actions.delete_product_serial_request,
      createSaga(actions, 'delete_product_serial', serialApi.deleteProductSerial, {
        isAlertSuccess: true,
      }),
    ),
  ]);
}

export default slice.reducer;
